// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "header[data-v-16667f14]{display:flex;justify-content:flex-end;align-items:center;position:absolute;top:0;left:0;width:100%;height:50px;padding:0 10px;z-index:1}header ul[data-v-16667f14]{margin:0;list-style-type:none}header .link[data-v-16667f14]{flex-direction:row-reverse;color:#fff;text-decoration:none}header .link .icon[data-v-16667f14]{width:1em;height:1em;margin-right:10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
